(function ($) {
	$(() => {

		window.frAtdHiddenFieldValues = [];

		const getGroupIndex = (classes, classPrefix) => {
			let result = false;
			classes.split(" ").forEach(cl => {
				if(cl.startsWith(classPrefix)){
					result = cl.replace(classPrefix, '');
				}
			});

			return result;
		}

		const checkIfSecondaryOptionBelongsToMain = ($main, $secOp) => {
			const intersection = JSON.parse($secOp.attr('atd-parents') || '[]').filter(value => ($main.val() || []).map(Number).includes(value));

			return intersection.length > 0;
		}

		$(window).on('fr:initialize-atd-gf-media-field-group', (ev, formId) => {
			const $form = $('#gform_'+formId);
			const $fields = $form.find('.atd-gf-media-field-group:not(.fr--atd-gf-media-field-group-initialized)');
			const indexes = [];

			$.each($fields, (i, el) =>  { 
				const $el = $(el);
				const index = getGroupIndex($el[0].className, 'atd-gf-media-field-group--');
				
				if(index !== false && !indexes.includes(index)){
					indexes.push(index);
				}
			});

			$.each(indexes, function (i, index) { 
				$fields.filter((j, field) => {
					return $(field).hasClass('atd-gf-media-field-group--'+index);
				}).wrapAll('<div class="gfield atd-gf-media-field-group-parent atd-gf-media-field-group-parent--'+index+'"></div>');
			});

			
			$.each($form.find('.atd-gf-media-field-group-parent'), (i, el) =>  { 
				const $group = $(el);
				const $toggler = $group.find('.atd-gf-media-field-group-toggler'); 
				
				$toggler.find('.gchoice > input').on('change', (ev) => {
					const $input = $(ev.target);
					const data = {
						target: $input.is(':checked') ? 'Add Media +' : 'Remove Media -',
						replacement: $input.is(':checked') ? 'Remove Media -' : 'Add Media +'
					};

					$(ev.target).parent().find('.gform-field-label').html($(ev.target).parent().find('.gform-field-label').html().replace(data.target, data.replacement));
				});
			});

			$fields.addClass('fr--atd-gf-media-field-group-initialized');
		});

		$(window).on('fr:initialize-atd-gf-pseudo-slide-appender', (ev, formId) => {
			const $form = $('#gform_'+formId);
			const $fields = $form.find('.atd-gf-slide-appender:not(.fr--slide-appender-initialized)');

			$.each($fields, (i, el) =>  { 
				const $field = $(el);
				const $input = $field.find('.ginput_container_number > input');

				$field.find('.ginput_container_number .atd-gf-button-appender-remove').on('click', () => {
					if (confirm('Are you sure you want to remove this row of data?')) {
						$input.val(parseInt($input.val()) - 1).trigger('change');
					}
				});
	
				$field.find('.ginput_container_number .atd-gf-button-appender-add').on('click', () => {
					$input.val(parseInt($input.val()) + 1).trigger('change');
				});

				$input.on('change', (ev) => {
					const $input = $(ev.target);
					const $buttons = $input.parent().find('.atd-gf-pseudo-appender');
					const min = parseInt($input.attr('min'));
					const max = parseInt($input.attr('max'));
					const current = parseInt($input.val());
					
					$buttons.css('display', '');
	
					if(current === min){
						$buttons.filter('.atd-gf-button-appender-remove').css('display', 'none');
					}
	
					if(current === max){
						$buttons.filter('.atd-gf-button-appender-add').css('display', 'none');
					}
				});
			});

			$fields.addClass('fr--slide-appender-initialized');
		});

		$(window).on('fr:initialize-atd-gf-synced-selects', (ev, formId) => {
			const $form = $('#gform_'+formId);
			const $fields = $form.find('.atd-gf-synced-select:not(.fr--atd-gf-synced-selects-initialized)');
			const indexes = [];

			$.each($fields, (i, el) =>  { 
				const $el = $(el);
				const index = getGroupIndex($el[0].className, 'atd-gf-synced-select-group--');
				
				if(index !== false && !indexes.includes(index)){
					indexes.push(index);
				}
			});

			$.each(indexes, function (i, index) { 
				const $group = $fields.filter((j, field) => {
					return $(field).hasClass('atd-gf-synced-select-group--'+index);
				});
				const $main = $group.filter('.atd-gf-synced-select-type--main');
				const $secondaries = $group.filter('.atd-gf-synced-select-type--secondary');

				if($main.length == 0 || $secondaries.length == 0) return;

				//initialize secondaries
				$.each($secondaries.find('select[atd-data-config]'), (j, secEl) =>  { 
					const $secEl = $(secEl);
					const config = JSON.parse($secEl.attr('atd-data-config') || '{}');

					if(Object.keys(config).length === 0) return;
					
					$.each($secEl.find('option'), (k, op) => { 
						const $option = $(op);
						const obj = config.find(o => o.value === parseInt($option.attr('value')));

						if(obj){
							$option.attr('atd-parents', JSON.stringify(obj.topics))
						}
					});
					
				});

				$main.find('select').on('change fr:init', (ev) => {
					const $currMainEl = $(ev.target);
					const $secondaryOptions = $secondaries.find('select[atd-data-config] option');

					$.each($secondaryOptions, (j, secOp) => {
						const $opt = $(secOp);
						const belongs = checkIfSecondaryOptionBelongsToMain($currMainEl, $opt);

						if(belongs){
							$opt.attr('disabled', false);
						}else{
							$opt.attr('disabled', 'disabled');
						}

						if($opt.parent().multiselect) $opt.parent().multiselect('refresh');
					});

					if(ev.type == 'fr:init'){
						$currMainEl.off('fr:multiselect-changed');
						$currMainEl.on('fr:multiselect-changed', (ev) => {
							const currVal = $(ev.currentTarget).val();
							$secondaries.toggleClass('atd-gf-select-disabled', !currVal.length);

							//Check if for every secondary, the current option selected is within the values
							//of the main one
							const $secondaryOptions = $secondaries.find('select[atd-data-config] option');

							//for each secondary, check the selected values
							//if the selected values do not correspond to any of the main elements values
							//then we need to remove the ones that do not correspond from the secondary's value
							$.each($secondaryOptions, (i, secOp) =>  { 
								const $option = $(secOp);
								const secondaryParents = JSON.parse($option.attr('atd-parents') || '[]').map(Number);
								const belongs = ((currVal || []).map(Number).filter(value => secondaryParents.includes(value))).length;

								if(!belongs) $option.prop('selected', false);
							});

							$.each($secondaries.find('select[atd-data-config]'), (i, sec) =>  { 
								const $sec = $(sec); 
								if($sec.multiselect) $sec.multiselect('refresh');
							});
						});

						//on init
						$currMainEl.trigger('fr:multiselect-changed');
					}
				});

				//init on page load
				$main.find('select').trigger('fr:init');
			});

			$fields.addClass('fr--atd-gf-synced-selects-initialized');
		});

		$(window).on('fr:initialize-atd-gf-custom-wysiwyg', (ev, formId) => {
			const $form = $('#gform_'+formId);
			const $fields = $form.find('.atd-gf-custom-wysiwyg:not(.fr--atd-gf-custom-wysiwyg-initialized)');
			const config = {
				// text alignment
				leftAlign: false,
				centerAlign: false,
				rightAlign: false,
				justify: false,
				// title
				heading: false,
				// fonts
				fonts: false,
				fontColor: false,
				backgroundColor: false,
				fontSize: false,
				// uploads
				imageUpload: false,
				fileUpload: false,
				// media
				videoEmbed: false,
				// tables
				table: false,
				// code
				removeStyles: false,
				useParagraph: true,
				code: false,
				useParagraph: true,
				height: 210
			};

			if($fields.length){
				$(window).on('fr:richtextjs-loaded', () => {
					$.each($fields, (i, el) =>  { 
						const $el = $(el);
						//Destroy if the richtext plugin has already been initialized
						if($el.find('.richText-editor').length){
							$el.find('.richText-editor').trigger('destroy');
						}
						$el.find('textarea').richText({
                            ...config,
                            ...{ heading: $el.hasClass('atd-gf-custom-wysiwyg-option--subtitle') },
                            ...( $el.find('textarea').is('[placeholder]') ? {placeholder: $el.find('textarea').attr('placeholder')} : {} )
                        });

						//fix visual issue when placeholder shows when it also has content
						if($el.find('textarea').is('[placeholder]')){
							$el.find('.richText-editor').trigger('focus');
							$el.find('.richText-editor').blur();
						} 
					});
				});

				$(window).trigger('fr:load-richtextjs');
			}

			$fields.addClass('fr--atd-gf-custom-wysiwyg-initialized');
		});

		$(window).on('fr:initialize-atd-gf-change-label-position', (ev, formId) => {
			const $form = $('#gform_'+formId);
			const $fields = $form.find('.gfield--type-repeater:not(fr-initialized)');
			
			if($fields.length){
				$.each($fields, (i, el) =>  {
					const $field = $(el); 
					const $desc = $field.find(' > .gfield_description');
					const $label = $field.find(' > .gfield_repeater_wrapper > fieldset.gfield_repeater > legend.gform-field-label'); 
					const descIsBelow = $field.hasClass('field_description_below');

					if($desc.length && $label.length){
						//litte bit of css
						$desc.css({
							paddingBottom: '0',
							paddingTop: '5px'
						});
						$label.css({marginBottom: 0});

						if(descIsBelow){
							$($desc.detach()).insertAfter($label.parent());
						}else{
							$($desc.detach()).insertAfter($label);
						}
						
					}

					$field.addClass('fr-repeater-initialized');
				});
			}
		});
		
		$(window).on('fr:initialize-atd-gf-prepopulate-fileupload', (ev, formId) => {
			const $form = $('#gform_'+formId);
			const $fields = $form.find('.gfield--type-hidden:not(fr-fileupload-initialized)');

			if($fields.length){
				$.each($fields, (i, el) =>  {
					const $field = $(el);
					let parentId = false;
					let $parent = false;
					const $input = $field.find('input[type="hidden"]');
					const previousVal = $input.val();
 
					if($field.is('[class*="atd-gf-previous-value-for--"]')){
						const classes = $field.attr('class').split(/\s+/);
						classes.forEach(className => {
							if(className.startsWith("atd-gf-previous-value-for--")){
								parentId = className.replace('atd-gf-previous-value-for--', '');
							}
						});
					}

					if(parentId){
						$parent = $form.find('#field_'+formId+'_'+parentId);
					}
					
					if($parent.length){
						const exists = window.frAtdHiddenFieldValues.find(item => item.parentId === parentId);
						if(exists === undefined){
							window.frAtdHiddenFieldValues.push({
								parentId: parentId,
								value: previousVal
							});

						}else{
							/**
							 * HACK FOR AJAX VALIDATION!
							 * 
							 * If the values were set before the ajax validation ran we need to set those values first
							 */

							const existingIndex = window.frAtdHiddenFieldValues.findIndex(item => item.parentId === parentId);
							if(existingIndex !== -1){
								window.frAtdHiddenFieldValues[existingIndex] = {
									parentId: parentId,
									value: window.frAtdHiddenFieldValues[existingIndex].value
								}

								//Set the input value
								$input.val(window.frAtdHiddenFieldValues[existingIndex].value);
							}
						}

						$input.on('change', (ev) => {
							ev.preventDefault();
							
							const existingIndex = window.frAtdHiddenFieldValues.findIndex(item => item.parentId === parentId);
							if(existingIndex !== -1){
								window.frAtdHiddenFieldValues[existingIndex] = {
									parentId: parentId,
									value: $input.val()
								}
							}
						});

						if($input.val() && $input.val().length){
							//set the HTML on the parent
							const $el = $('<div class="atd-gf-previous-upload-dialog"><div class="atd-gf-previous-upload-dialog-text-container"><p><b>Previously Uploaded Content</b></p><p><i>Click the X button to remove and upload new content to this field.</i></p><div class="atd-gf-close-prev close-btn"></div></div><div class="atd-gf-previous-upload-dialog-images-wrapper"></div></div>');

							const isParentMultiple = $parent.hasClass('atd-gf-is-multiple-upload');

							const prevData = isParentMultiple ? JSON.parse($input.val() || '[]') : [$input.val()];

							prevData.forEach(prevEl => {

								//TO DO if file
								const isImage = prevEl.match(/^http.*\.(jpeg|jpg|gif|png)$/) != null;

								if(isImage){
									const $img = $('<img src="'+prevEl+'" class="atd-gf-previous-images-thumb" />');

									$el.find('.atd-gf-previous-upload-dialog-images-wrapper').append($img);
								}else{
									const filename = prevEl.split('/').pop();

									const $fileIcon = '<div class="atd-gf-file-icon"><div class="atd-gf-icon-svg"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="60px" height="60px"> <path d="M24.707,8.793l-6.5-6.5C18.019,2.105,17.765,2,17.5,2H7C5.895,2,5,2.895,5,4v22c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2 V9.5C25,9.235,24.895,8.981,24.707,8.793z M18,10c-0.552,0-1-0.448-1-1V3.904L23.096,10H18z"/></svg></div><div class="atd-gf-icon-filename">'+filename+'</div></div>';
									$el.find('.atd-gf-previous-upload-dialog-images-wrapper').append($fileIcon);
								}
							});

							$el.find('.atd-gf-close-prev').on('click', (ev) => {
								ev.preventDefault();
								$input.val('').trigger('change');
								$el.remove();
							});

							$parent.append($el);
						}
					}

					$field.addClass('fr-fileupload-initialized');
				});
			}
		});

	});
})(jQuery);